import { Inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { Relay42Category } from '@mnz-core/models/_enums';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { IRelay42Data } from '@mnz-core/models/relay42-data';

declare interface MyExtendedWindow extends Window {
   /* Relay42 function definition  */
  _st: (action: string, ...args: any[]) => void;
}

const extendedWindow = (window as Window) as MyExtendedWindow;

@Injectable({
  providedIn: 'root'
})
export class Relay42Service {
  private _showRelayEvents: boolean;
  private _relay42Title = new Map<string, string>([
    ['/', 'Kies login rol'],
    ['/inloggen/contactpersoon', 'Inloggen als contactpersoon'],
    ['/inloggen/kaarthouder', 'Inloggen als kaarthouder'],
    ['/inlog-vergeten/contactpersoon', 'Inlog vergeten contactpersoon'],
    ['/inlog-vergeten/kaarthouder', 'Inlog vergeten kaarthouder'],
    ['/account-activeren', 'Account activeren'],
    ['/vertraagd-betalen', 'Vertraagd betalen']
  ]);

  constructor(@Inject(APP_CONFIG) private readonly _config: IAppConfiguration) {
    try {
      this._showRelayEvents = !!JSON.parse(localStorage.getItem('showRelayEvents'));
    } catch (e) {
      /* ignored */
    }
  }

  /**
   * Publish a single event to relay42
   *
   * @description events with a data object gets relayed to Google Analytics (only name, type)
   *
   * @param categoryId click event
   * @param actionId the action that is performed. e.g. 'purchase'
   * @param data the data that should be send to Google Analytics
   */
  public publishEvent(
    categoryId: Relay42Category,
    actionId: string = null,
    data: IRelay42Data = { name: 'no_label', type: 'button' }
  ): void {
    this._relay42Fn('publishEvent', categoryId, actionId, data);
  }

  /**
   * Publish the complete page structure to relay42
   * @description The page structure defines the structure of the page.
   * e.g. the application name, page title, platform etc
   * @param relativeUrl the current url
   */
  public publishPage(relativeUrl: string): void {
    const { nsenvironment, language, preview } = this._config.relay42_config;
    const { name } = environment;

    this._relay42Fn('resetTags');
    this._relay42Fn('setPageStructure', 'Applicatie', name, this._relay42Title.get(relativeUrl) || relativeUrl);
    this._relay42Fn('addTagProperties', {
      language,
      nsenvironment,
      preview
    });
    this._relay42Fn('loadTags');
  }

  private _relay42Fn(action: string, ...args: any[]): void {
    const relay42 = extendedWindow._st;

    if (this._showRelayEvents) {
      console.log(`R42[${relay42 ? 'P' : 'D'}]: Action => `, { action }, ': Arguments => ', {
        args
      });
    }

    try {
      relay42(action, ...args);
    } catch (error) {
      // ignored
    }
  }
}
